import BorderBox5 from './main'
export default function (Vue) {
  Vue.component(BorderBox5.name, BorderBox5)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-5/index.js